<template>
  <div class="mod prefecture">
    <div class="top-banner">
      <span class="about-label banner-txt-con" :style="{left:`${left}px`}">
        {{ $t('prefecturename') }} 
      </span>
      <!-- <img src="@/assets/img/prefecture.png" @load="bannerloadEvent"/> -->
    </div> 
    <div class="linkBox">
    <div class="link-tab">
      <div @click="tabEvent(0, 'tabone',-150)" :class="btnActiveIndex === 0 ? 'link-btn link-btn-active' : 'link-btn'">
        {{ $t('patient-btn-txt1') }}</div>
      <div @click="tabEvent(1, 'tabtwo',-220)" :class="btnActiveIndex === 1 ? 'link-btn link-btn-active two' : 'link-btn two'">
        {{ $t('patient-btn-txt2') }}</div>
    </div>
    </div>
    <div class="patient-container">

    <div class="submain " id="tabone">
      <div class="titleWrapper"><span class="title">{{ $t('patient-btn-txt1') }}</span></div>
      <div class="block2">
        <div class="perTabwrapperWrap">
          <div class="perTabwrapper">
            <span class="tabNav " :class="{ active: selectType === 'one' }" @click="switchEvent('one')">{{ $t('patient-sub-btn-txt1') }}</span>
            <span class="tabNav" :class="{ active: selectType === 'two' }" @click="switchEvent('two')">{{ $t('patient-sub-btn-txt2') }}</span>
          </div>
          <div class="one switchbox" v-if="selectType === 'one'">
            <span class="article" :class="{'en':isEn}">{{ $t('patient-s-txt1') }}</span>
            <div class="wrapper1">
             
              <span class="summary"> <img class="iconItem0" src="@/assets/img/prefecture/images/img_11.svg" />{{ $t('patient-s1-txt1') }}</span>
           
              <span class="summary"> <img class="iconItem0" src="@/assets/img/prefecture/images/img_11.svg" />{{ $t('patient-s1-txt2') }}</span>
            
              <span class="summary"> <img class="iconItem0" src="@/assets/img/prefecture/images/img_11.svg" />{{ $t('patient-s1-txt3') }}</span>
             
              <!-- <span class="summary"> <img class="iconItem0" src="@/assets/img/prefecture/images/img_11.svg" />{{ $t('patient-s1-txt4') }}</span> -->
            </div>
          </div>

          <div class="two switchbox" v-else>
            <span class="article"> {{ $t('patient-s-txt2') }}
              <span class="mailcolor">kanglin@kanglinbio.com</span></span>
            <div class="wrapper1">
              
              <span class="summary"><img class="iconItem0" src="@/assets/img/prefecture/images/img_11.png" />{{ $t('patient-s2-txt1') }}</span>
            
              <span class="summary"><img class="iconItem0" src="@/assets/img/prefecture/images/img_11.png" />{{ $t('patient-s2-txt2') }}</span>
              <span class="summary"><img class="iconItem0" src="@/assets/img/prefecture/images/img_11.png" />{{ $t('patient-s2-txt3') }}</span>
              <span class="summary"><img class="iconItem0" src="@/assets/img/prefecture/images/img_11.png" />{{ $t('patient-s2-txt4') }}</span>
            </div>
          </div>
        </div>
        <div class="container1">
          <img class="item" src="@/assets/img/prefecture/images/img_15.webp" />
        </div>
      </div>
    </div>
    
    <div  id="tabtwo" class="">
    <div class="main">

      <div class="block3">
        <div class="titleWrapper1"><span class="title1">{{ $t('patient-btn-txt2') }}</span></div>
      </div>
    
      <div class="">
        <div class="patient_itemboxWrap">
       
            <div class="patient_itembox">
              <div class="container2" >
                <!-- :style="{backgroundImage:'url('+item.imageUrl +')'}"  -->
                <img class="swiperImg" :src="currentSwiperImg" />
              </div>
        
              <div class="container3Wrap">
                <div class="container3 swiper-container">
                <div class="wrapper2 swiper-wrapper">
                  <div class="group swiper-slide" v-for="(item, index) in storyList" :key="item.title + index">
                    <div>
                      <span class="caption prefect-title">{{ item.title }}</span>
                      <span class=" prefect-line"></span>
                      <span class="article1">{{ item.briefContent }}</span>
                      <div class="view" @click="detailEvent(item.id)" :class="{'isEn':isEn}">
                        <span class="word cursorpointer">{{ $t('read-more') }}</span>
                        <img class="dot2" src="@/assets/img/yuedu-right1.svg" />
                      </div>
                    </div>
                  </div>
                </div>

             
              </div>
              <div class="swiper-button-box">
                <div class="swiper-button-prev">
                  <img class="" src="@/assets/img/prefecture/images/right.png" />
                </div>
                <div class="swiper-button-next">
                  <img class="" src="@/assets/img/prefecture/images/left.png" />
                </div>
              </div>
            
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination" v-if="storyList.length > 1"></div>


              </div>
            </div>
         

        </div>
      
     
    </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { fetPatientStoryList } from '@/api/index'
import { menuFixed } from '@/utils/index'

export default {
  components: {

  },
  data () {
    return {
      btnActiveIndex: 0,
      selectType: 'one',
      storyList: [],
      left:'',
      isEn: localStorage.getItem("lang") === 'EN',
      currentSwiperImg: ''
    }
  },
  methods: {
    bannerloadEvent(){
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74  - $('.top-banner').offset().left
    },
    getData () {
      fetPatientStoryList({
        language: localStorage.getItem('lang') || 'CN'
      }).then(res => {
        this.storyList = res.data
        this.currentSwiperImg = res.data[0]['imageUrl']
        setTimeout(() => {
          this.swiperEvent()
        },100)
      })
    },
    switchEvent (type) {
      this.selectType = type
    },
    swiperEvent () {
      let that =this
      var swiper = new Swiper('.swiper-container', {
        autoplay: 8000,
        speed: 800,
        // loop: this.storyList.length > 1,
        loop: false,
        autoplay: false,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        autoplayDisableOnInteraction: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        paginationClickable: true,
        on:{
          slideChange: function(){
            let curIndex =  this.activeIndex
            that.currentSwiperImg = that.storyList[curIndex]['imageUrl']
          },
        },

      });
    },

    tabEvent (index, id,num=0) {
      this.btnActiveIndex = index
      let isfixed =  $('.linkBox').css('position') === 'fixed'
      let offset = index == 0 && isfixed ? 65 : 0
      if(!isfixed && index!==0){
        offset -= 65
      }
      const top = $('#'+ id).offset().top - 134 + offset - num
      console.log(top)
      $("html,body").animate({scrollTop: top},500);
    },
    detailEvent(id){
      this.$router.push({
        name:'newsdetail',
        query:{
          id,
          type:'noLeft'
        }
      })
    },
    onScrollSwitchTabPre(){
      var that = this
      window.addEventListener('scroll', function () {
        var tarElArr = [$("#tabone"), $("#tabtwo")]
        var tarElScrollArr = [tarElArr[0].offset().top - 110, 
        tarElArr[1].offset().top - 110
        ] 
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        console.log(scrollTop)
        if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
          that.btnActiveIndex = 0

        }
        else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
          that.btnActiveIndex = 0
        } else {
          that.btnActiveIndex = 1
        }

        console.log('this.btnActiveIndex'+ that.btnActiveIndex)
    })
    },

  },
  mounted () {
    this.getData()
    menuFixed()
    setTimeout(()=>{
      this.bannerloadEvent()
      this.onScrollSwitchTabPre()
    },100)
  }
}
</script>
<style lang="less">
.top-banner{
      width: 100%;
      background: url(../../assets/img/webp/prefecture.webp) no-repeat top;
      background-size: cover;
  }

.prefecture .swiper-pagination{
  bottom: -90px;
  left: 0px;
}

.prefecture .swiper-pagination-bullet {
  background-color: gray;
    width: 10px;
    height: 4px;
    margin-left: 8px;
    -ms-flex-item-align: center;
    align-self: center;
    border-radius: 2px;
}
.prefecture .swiper-pagination-bullet-active {
  border-radius: 20px;
  background-color: #2db3d0;
  width: 30px;
    height: 4px;
    border-radius: 2px;
}
.prefecture .swiper-button-next, .prefecture  .swiper-button-prev{
  bottom:10px;
  background-image:none;
  width:auto;
}
.prefecture .swiper-button-next{
  left:0px;
  img{
    width: 40px;
    height: 40px;
  }
}
.prefecture  .swiper-button-prev{
  left: 59px;
  img{
    width: 40px;
    height: 40px;
  }
}
.swiper-button-box{
  position: absolute;
  right: 0;
  bottom: -72px;
  width: 100px;
}
.prefect-title{
 &::after{
  // position: absolute;
  // content: '';
  // display: block;
  // width: 150px;
  // height: 2px;
  // background: #2db3d0;
  // bottom: -10px;
  // left: 0;
 }
}

.prefect-line{
  display: block;
  width: 150px;
  height: 4px;
  background: #2db3d0;
  border-radius: 2px;
  margin-top: 28px;
  // margin-left: 19px;
}
.swiperWrap{
  position: relative;
 
}
.patient-box2{
  width: 1278px;
  display: flex;
    margin: 0 auto ;
    justify-content: flex-start;
}
</style>

<style src="./index.css" scoped/>
;



// WEBPACK FOOTER //
// src/view/Prefecture/index.vue